import type { CmmdContextPaths as CmmdForgePaths } from "@cmmd-forge/contracts";

import { requestRuntime, type CmmdForgeRuntimeApiConfig } from "./cmmdRuntimeRequest";

export type CmmdCloudProjectRemovalOperation =
  CmmdForgePaths["/api/forge/context/cloud-projects/{projectId}/removal"]["post"]["responses"][202]["content"]["application/json"]["data"]["operation"];

export type CmmdCloudProjectRemovalPreview =
  CmmdForgePaths["/api/forge/context/cloud-projects/{projectId}/removal-preview"]["get"]["responses"][200]["content"]["application/json"]["data"]["preview"];

export function previewCloudProjectRemoval(
  config: CmmdForgeRuntimeApiConfig,
  input: { readonly projectId: number; readonly signal?: AbortSignal },
): Promise<CmmdCloudProjectRemovalPreview> {
  return requestRuntime<{ preview: CmmdCloudProjectRemovalPreview }>(
    config,
    {
      method: "GET",
      path: `/api/forge/context/cloud-projects/${encodeURIComponent(String(input.projectId))}/removal-preview`,
      ...(input.signal !== undefined ? { signal: input.signal } : {}),
    },
    config.cloudProjectRemovalPreviewUrl
      ? () => config.cloudProjectRemovalPreviewUrl!(input.projectId)
      : undefined,
  ).then((response) => response.preview);
}

export function requestCloudProjectRemoval(
  config: CmmdForgeRuntimeApiConfig,
  input: {
    readonly projectId: number;
    readonly idempotencyKey: string;
    readonly deletePlanningProject: boolean;
    readonly deleteCheckoutFiles?: boolean;
    readonly previewToken?: string;
    readonly forceDirty?: boolean;
    readonly signal?: AbortSignal;
  },
): Promise<CmmdCloudProjectRemovalOperation> {
  return requestRuntime<{ operation: CmmdCloudProjectRemovalOperation }>(
    config,
    {
      method: "POST",
      path: `/api/forge/context/cloud-projects/${encodeURIComponent(String(input.projectId))}/removal`,
      body: {
        idempotencyKey: input.idempotencyKey,
        deletePlanningProject: input.deletePlanningProject,
        ...(input.deleteCheckoutFiles !== undefined
          ? { deleteCheckoutFiles: input.deleteCheckoutFiles }
          : {}),
        ...(input.previewToken !== undefined ? { previewToken: input.previewToken } : {}),
        ...(input.forceDirty !== undefined ? { forceDirty: input.forceDirty } : {}),
      },
      ...(input.signal !== undefined ? { signal: input.signal } : {}),
    },
    config.cloudProjectRemovalUrl
      ? () => config.cloudProjectRemovalUrl!(input.projectId)
      : undefined,
  ).then((response) => response.operation);
}
